/* [BRAND] — PDP-Konfigurator
   Datei: assets/lm-configurator.js
   Kein Framework, keine Abhaengigkeiten. Laeuft mit defer.
   Reihenfolge: Upload -> Preview -> Personalisierung -> Groesse -> Rahmen -> Extras.
   Alle Schritte sind von Anfang an bedienbar (Groesse/Preis sofort sichtbar, wie C&P);
   das Foto ist nur fuer Preview und Warenkorb Pflicht. Der Rahmen ist ein DOM-Overlay, kein Serverjob.
*/
(function () {
  'use strict';

  var PROGRESS = {
    regal:   ['Reading the light…', 'Placing the crown…', 'Adjusting the shadows…'],
    studio:  ['Reading the light…', 'Setting the background…', 'Adding the name…'],
    forever: ['Reading the light…', 'Softening the light…', 'Almost there…']
  };

  /* Studio-Hintergründe (templates-spec.md, identisch mit backend/templates/manifest.json) */
  var BACKGROUNDS = [['Bone', '#EDE7DC'], ['Sage', '#B7C3B4'], ['Clay', '#C69B7B'], ['Slate', '#6B7780'], ['Ink', '#2B2F33'], ['Blush', '#E4CBC4']];

  var FRAME_SWATCH = {
    Unframed: 'transparent',
    Black: '#1b1b1b',
    White: '#f4f2ee',
    Natural: '#c8a373',
    Espresso: '#4a3225'
  };

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function el(root, sel) { return root.querySelector(sel); }
  function els(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function Configurator(root) {
    this.root = root;
    this.api = (root.dataset.apiBase || '').replace(/\/$/, '');
    this.threshold = parseFloat(root.dataset.freeShippingThreshold || '59') * 100;
    this.hasFrame = root.dataset.hasFrame === 'true';
    this.form = root.dataset.form || 'canvas';   /* canvas | poster | blanket | pillow | mug | ornament */

    this.variants = JSON.parse(el(root, '[data-lm-variants]').textContent);
    this.optionNames = JSON.parse(el(root, '[data-lm-option-names]').textContent);
    try { this.catalog = JSON.parse((el(root, '[data-lm-template-catalog]') || { textContent: '[]' }).textContent); } catch (e) { this.catalog = []; }

    this.state = {
      sessionToken: null,
      uploads: [],          // [{id, species, thumb}]
      collection: 'regal',
      species: null,
      templateId: null,
      templateName: null,
      previewId: null,
      previewUrl: null,
      previewCount: 0,
      personalization: {},
      size: null,
      frame: this.hasFrame ? 'Unframed' : null,
      addons: [],
      confirmed: false,
      renderVersion: null,
      adjust: []            // HeadAdjust je Upload: {upload_id, offset_x, offset_y, scale, rotation_deg}
    };

    // Template-Produkt (Crown-&-Paw-Logik): Stil ist durch das Produkt vorgegeben
    this.locked = false;
    if (root.dataset.templateId) {
      this.state.templateId = root.dataset.templateId;
      this.state.templateName = root.dataset.templateName || root.dataset.templateId;
      if (root.dataset.collection) this.state.collection = root.dataset.collection;
      this.locked = true;
    }

    this.bind();
    this.renderBackgrounds();
    this.applyCollectionFields();
    this.renderSizes();
    if (this.hasFrame) this.renderFrames();
    /* Auch auf einer Stil-Seite werden die Kacheln sofort gerendert: der Schritt ist dort nicht mehr
       eingeklappt, und ein leeres Kachelfeld saehe aus wie ein Ladefehler. renderTemplates markiert
       die aktuelle Vorlage per aria-pressed. */
    this.loadTemplates();
    this.updateBar();
  }

  /* ---------------- Session ---------------- */

  Configurator.prototype.session = function () {
    var self = this;
    if (this.state.sessionToken) return Promise.resolve(this.state.sessionToken);
    return fetch(this.api + '/session', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ shop_session_id: this.shopSessionId() })
    })
      .then(function (r) { return r.json(); })
      .then(function (j) { self.state.sessionToken = j.session_token; return j.session_token; });
  };

  Configurator.prototype.shopSessionId = function () {
    try {
      var k = 'lm_sid', v = sessionStorage.getItem(k);
      if (!v) { v = 'sid_' + Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem(k, v); }
      return v;
    } catch (e) { return 'sid_nostorage'; }
  };

  /* ---------------- Events ---------------- */

  Configurator.prototype.bind = function () {
    var self = this, root = this.root;

    var drop = el(root, '[data-lm-drop]');
    var file = el(root, '[data-lm-file]');
    drop.addEventListener('click', function () { file.click(); });
    drop.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); file.click(); }
    });
    drop.addEventListener('dragover', function (e) { e.preventDefault(); drop.classList.add('is-over'); });
    drop.addEventListener('dragleave', function () { drop.classList.remove('is-over'); });
    drop.addEventListener('drop', function (e) {
      e.preventDefault(); drop.classList.remove('is-over');
      if (e.dataTransfer.files && e.dataTransfer.files[0]) self.upload(e.dataTransfer.files[0]);
    });
    file.addEventListener('change', function () { if (file.files[0]) self.upload(file.files[0]); });

    els(root, '[data-lm-collection]').forEach(function (tab) {
      tab.addEventListener('click', function () { self.setCollection(tab.dataset.lmCollection); });
    });

    els(root, '[data-lm-species-group] input[type="radio"]').forEach(function (r) {
      r.addEventListener('change', function () { self.setSpecies(r.value); });
    });

    ['pet_name', 'year_from', 'year_to', 'dedication'].forEach(function (key) {
      var input = el(root, '[data-lm-input="' + key + '"]');
      if (!input) return;
      var t;
      input.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () { self.setPersonalization(key, input.value); }, 450);
      });
    });

    els(root, '[data-lm-addon]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var key = cb.dataset.lmAddon;
        var i = self.state.addons.indexOf(key);
        if (cb.checked && i < 0) {
          self.state.addons.push(key);
          self.track('AddonSelected', { addon: key, addon_value: parseFloat(cb.dataset.price || '0') });
        } else if (!cb.checked && i >= 0) {
          self.state.addons.splice(i, 1);
        }
        self.updateBar();
      });
    });

    var confirm = el(root, '[data-lm-confirm]');
    confirm.addEventListener('change', function () {
      self.state.confirmed = confirm.checked;
      if (confirm.checked) {
        self.state.approvedAt = new Date().toISOString();
        self.track('PreviewApproved', {
          template_id: self.state.templateId,
          previews_before_approve: self.state.previewCount
        });
      }
      self.updateBar();
    });

    el(root, '[data-lm-submit]').addEventListener('click', function () { self.submit(); });

    els(root, '[data-lm-action]').forEach(function (b) {
      b.addEventListener('click', function () { self.action(b.dataset.lmAction); });
    });
  };

  Configurator.prototype.action = function (name) {
    if (name === 'change-photo' || name === 'add-pet') {
      el(this.root, '[data-lm-file]').click();
    } else if (name === 'another-style') {
      this.locked = false;
      var st = this.stepEl('style');
      if (st) { st.removeAttribute('data-lm-collapsed'); st.dataset.state = 'open'; }
      this.loadTemplates();
      this.focusStep('style');
    } else if (name === 'adjust') {
      this.openAdjust();
    } else if (name === 'photo-later') {
      this.emailUploadLink();
    } else if (name === 'size-guide') {
      var sg = el(this.root, '[data-lm-size-guide]');
      if (sg) { if (typeof sg.showModal === 'function') sg.showModal(); else sg.setAttribute('open', ''); this.track('SizeGuideOpened', {}); }
      document.dispatchEvent(new CustomEvent('lm:open-size-guide'));
    }
  };

  /* ---------------- Upload ---------------- */

  Configurator.prototype.upload = function (fileObj) {
    var self = this;
    var errEl = el(this.root, '[data-lm-photo-error]');
    errEl.hidden = true;

    var max = this.maxPets();
    if (this.state.uploads.length >= max) {
      errEl.textContent = max === 1
        ? 'This product holds one pet. Choose a canvas or a blanket for two or three.'
        : 'This product holds up to ' + max + ' pets. Choose a canvas for three.';
      errEl.hidden = false;
      return;
    }

    this.busy = true;
    this.setDropBusy(fileObj);
    this.setSubmit('Checking your photo…', true);

    this.session()
      .then(function () { return self.downscale(fileObj); })
      .then(function (blob) {
        var fd = new FormData();
        fd.append('file', blob, 'photo.webp');
        fd.append('species_hint', self.state.species || 'auto');
        return fetch(self.api + '/uploads', {
          method: 'POST',
          headers: { Authorization: 'Bearer ' + self.state.sessionToken },
          body: fd
        });
      })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        self.busy = false;
        self.setDropBusy(null);
        if (!res.ok) {
          errEl.textContent = res.body.message || 'We could not use that photo. Please try another one.';
          errEl.hidden = false;
          self.track('PhotoRejected', { reject_code: res.body.code });
          self.updateBar();
          return;
        }
        var u = res.body;
        self.state.uploads.push({ id: u.upload_id, species: u.species_detected });
        if (u.species_detected && u.species_detected !== 'unknown') {
          var radio = el(self.root, '[data-lm-species-group] input[value="' + u.species_detected + '"]');
          if (radio && !radio.checked) { radio.checked = true; }
          if (self.state.species !== u.species_detected) { self.state.species = null; self.setSpecies(u.species_detected); }
        }
        self.track('PhotoUploaded', { species: u.species_detected, cache_hit: !!u.cache_hit });
        self.renderThumbs();
        self.completeStep('photo');
        if (self.state.templateId) {
          self.generate();
        } else {
          self.focusStep('style');
          var se = el(self.root, '[data-lm-style-error]');
          se.textContent = 'Pick a style to build your preview.'; se.hidden = false;
        }
        self.renderSizes(); if (self.hasFrame) self.renderFrames();
      })
      .catch(function () {
        self.busy = false;
        self.setDropBusy(null);
        errEl.textContent = 'Something went wrong on our side. Please try again in a moment.';
        errEl.hidden = false;
        self.updateBar();
      });
  };

  /* Zwischen "Foto gewaehlt" und "Preview da" lagen mehrere Sekunden, in denen sich sichtbar nichts
     tat: nur die Beschriftung des Kaufbuttons wechselte, ganz unten am Bildschirmrand, oft ausserhalb
     des Sichtfelds. Wer das nicht bemerkt, tippt ein zweites Mal. Die Upload-Flaeche quittiert deshalb
     selbst - mit dem eigenen Foto als Vorschau (lokal ueber createObjectURL, kein Netz noetig) und
     einem unbestimmten Balken. Unbestimmt mit Absicht: den echten Fortschritt kennen wir nicht. */
  Configurator.prototype.setDropBusy = function (fileObj) {
    var drop = el(this.root, '[data-lm-drop]');
    if (!drop) return;
    var title = el(drop, '.lm-drop__title');
    var old = el(drop, '.lm-drop__preview');
    var bar = el(drop, '.lm-drop__bar');
    if (old) { if (old.src && old.src.slice(0, 5) === 'blob:') URL.revokeObjectURL(old.src); old.parentNode.removeChild(old); }
    if (bar) bar.parentNode.removeChild(bar);
    if (!fileObj) {
      drop.classList.remove('is-busy');
      if (title && this.dropTitle) title.textContent = this.dropTitle;
      return;
    }
    drop.classList.add('is-busy');
    if (title) {
      if (!this.dropTitle) this.dropTitle = title.textContent;
      title.textContent = 'Checking your photo…';
    }
    var img = document.createElement('img');
    img.className = 'lm-drop__preview';
    img.alt = '';
    img.width = 56; img.height = 56;
    try { img.src = URL.createObjectURL(fileObj); } catch (e) { /* kein Preview, der Balken bleibt */ }
    var b = document.createElement('span');
    b.className = 'lm-drop__bar';
    b.appendChild(document.createElement('i'));
    if (title) drop.insertBefore(img, title); else drop.appendChild(img);
    drop.appendChild(b);
  };

  // Clientseitig auf 2400 px lange Kante skalieren, spart Uploadzeit im Mobilfunknetz
  Configurator.prototype.downscale = function (fileObj) {
    return new Promise(function (resolve) {
      var img = new Image();
      var url = URL.createObjectURL(fileObj);
      img.onload = function () {
        var max = 2400;
        var scale = Math.min(1, max / Math.max(img.width, img.height));
        if (scale === 1 && fileObj.size < 4 * 1024 * 1024) { URL.revokeObjectURL(url); return resolve(fileObj); }
        var c = document.createElement('canvas');
        c.width = Math.round(img.width * scale);
        c.height = Math.round(img.height * scale);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        c.toBlob(function (blob) { URL.revokeObjectURL(url); resolve(blob || fileObj); }, 'image/webp', 0.92);
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve(fileObj); };
      img.src = url;
    });
  };

  Configurator.prototype.renderThumbs = function () {
    var list = el(this.root, '[data-lm-thumbs]');
    list.innerHTML = this.state.uploads.map(function (u, i) {
      return '<li class="lm-thumb"><span>Pet ' + (i + 1) + '</span></li>';
    }).join('');
    var addBtn = el(this.root, '[data-lm-action="add-pet"]');
    addBtn.hidden = this.state.uploads.length >= this.maxPets();
  };

  /* Wie viele Tiere das Produkt wirklich kann - aus der Variantenachse, nicht geraten.
     Becher und Ornament koennen 1, die Decke 2, Wandbilder 3. Vorher stand hier eine 3;
     wer auf der Becherseite drei Tiere hochlud, lief bis zum Warenkorb und bekam dort
     "That combination is not available". Der Deckel gehoert an den Anfang, nicht ans Ende. */
  Configurator.prototype.maxPets = function () {
    var vals = this.uniqueOption('Pets').map(Number).filter(function (n) { return n > 0; });
    return vals.length ? Math.max.apply(null, vals) : 1;
  };

  /* ---------------- Templates und Preview ---------------- */

  Configurator.prototype.applyCollectionFields = function () {
    var c = this.state.collection;
    els(this.root, '[data-lm-collection]').forEach(function (t) {
      t.setAttribute('aria-selected', String(t.dataset.lmCollection === c));
    });
    el(this.root, '[data-lm-field="years"]').hidden = c !== 'forever';
    el(this.root, '[data-lm-field="dedication"]').hidden = c !== 'forever';
    el(this.root, '[data-lm-field="background"]').hidden = c !== 'studio';
  };

  Configurator.prototype.renderBackgrounds = function () {
    var self = this;
    var box = el(this.root, '[data-lm-backgrounds]');
    if (!box) return;
    box.innerHTML = BACKGROUNDS.map(function (b, i) {
      return '<button type="button" class="lm-swatch" role="radio" aria-checked="' + (i === 0) + '" data-bg="' + b[0] + '" title="' + b[0] + '">' +
             '<span class="lm-swatch__dot" style="background:' + b[1] + '"></span><span class="lm-swatch__label">' + b[0] + '</span></button>';
    }).join('');
    this.state.personalization.background = BACKGROUNDS[0][0];
    els(box, '.lm-swatch').forEach(function (b) {
      b.addEventListener('click', function () {
        els(box, '.lm-swatch').forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
        b.setAttribute('aria-checked', 'true');
        self.setPersonalization('background', b.dataset.bg);
      });
    });
  };

  /* Hund/Katze: sichtbare Folge — Hinweis, Stil-Labels, und bei bestehendem Preview neu rendern */
  Configurator.prototype.setSpecies = function (sp) {
    if (this.state.species === sp) return;
    this.state.species = sp;
    var note = el(this.root, '[data-lm-species-note]');
    if (note) {
      note.textContent = sp === 'cat' ? (this.root.dataset.noteCat || 'Every style below has its own cat version.')
                                      : (this.root.dataset.noteDog || 'Every style below is built for dogs.');
      note.hidden = false;
    }
    var box = el(this.root, '[data-lm-templates]');
    if (box) box.setAttribute('data-species', sp);
    this.root.setAttribute('data-species', sp);
    els(this.root, '[data-lm-species-out]').forEach(function (o) { o.textContent = sp === 'cat' ? 'cat' : 'dog'; });
    /* Auch das grosse Galeriebild folgt der Auswahl: die Miniatur mit passender Spezies wird angeklickt.
       Ein zweites Bildset waere Pflegeaufwand ohne Nutzen - die Miniaturen tragen die Quellen bereits. */
    var gthumb = document.querySelector('[data-lm-thumb][data-species="' + sp + '"]');
    if (gthumb && !gthumb.classList.contains('is-active')) gthumb.click();
    this.loadTemplates();
    this.track('SpeciesSelected', { species: sp });
    if (this.state.uploads.length && this.state.templateId) this.generate();
  };

  Configurator.prototype.setCollection = function (c) {
    this.state.collection = c;
    this.applyCollectionFields();
    this.loadTemplates();
  };

  Configurator.prototype.renderTemplates = function (list) {
    var self = this;
    var box = el(this.root, '[data-lm-templates]');
    box.innerHTML = list.map(function (t) {
      var name = (t.name || '').replace(/"/g, '&quot;');
      /* Die Kachel zeigt die gewaehlte Spezies. Vorher hing hier immer thumbnail_url - also der Hund -
         waehrend das Label darunter "cat" sagte. Genau der Widerspruch, den die Zeile darueber ausraeumen
         soll ("jeder Stil hat seine eigene Katzenversion"). thumb_dog/thumb_cat kommen aus dem Katalog im
         Section-Markup, thumbnail_url bleibt der Rueckfall fuer die Preview-API. */
      var thumb = (self.state.species === 'cat' ? (t.thumb_cat || t.thumbnail_url) : (t.thumb_dog || t.thumbnail_url)) || '';
      var altSp = self.state.species === 'cat' ? 'cat' : 'dog';
      /* Ohne das Abschneiden von "The" stand im Alt-Text "in the The Marquise style". */
      var altName = name.replace(/^The\s+/i, '');
      var img = thumb
        ? '<img src="' + thumb + '" alt="A ' + altSp + ' in the ' + altName + ' style" width="200" height="267" loading="lazy">'
        : '<span class="lm-template__ph" aria-hidden="true">' + name.replace(/^The\s+/i, '').split(' ').map(function (w) { return w.charAt(0); }).join('').slice(0, 2) + '</span>';
      var sp = self.state.species ? (self.state.species === 'cat' ? ' · cat' : ' · dog') : '';
      return '<button type="button" class="lm-template" data-template-id="' + t.template_id + '" data-template-name="' + name + '" aria-pressed="false">' + img + '<span>' + name + '<em class="lm-template__sp">' + sp + '</em></span></button>';
    }).join('');
    els(box, '.lm-template').forEach(function (b) {
      if (b.dataset.templateId === self.state.templateId) b.setAttribute('aria-pressed', 'true');
      b.addEventListener('click', function () { self.pickTemplate(b); });
    });
  };

  Configurator.prototype.loadTemplates = function () {
    var self = this;
    var box = el(this.root, '[data-lm-templates]');
    var c = this.state.collection;
    var local = (this.catalog || []).filter(function (t) { return t.collection === c; });
    if (local.length) { this.renderTemplates(local); return; } /* Katalog aus dem Shop: sofort, ohne Netz */
    if (!this.api) { box.innerHTML = '<p class="lm-note">No styles in this collection yet.</p>'; return; }
    var q = '?collection=' + encodeURIComponent(c);
    if (this.state.species) q += '&species=' + encodeURIComponent(this.state.species);
    fetch(this.api + '/templates' + q)
      .then(function (r) { return r.json(); })
      .then(function (j) { self.renderTemplates(j.templates || []); })
      .catch(function () { box.innerHTML = '<p class="lm-error">Styles could not be loaded. Please refresh the page.</p>'; });
  };

  Configurator.prototype.pickTemplate = function (btn) {
    els(this.root, '.lm-template').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    btn.setAttribute('aria-pressed', 'true');
    this.state.templateId = btn.dataset.templateId;
    this.state.templateName = btn.dataset.templateName;
    el(this.root, '[data-lm-style-error]').hidden = true;
    this.completeStep('style');
    if (this.state.uploads.length) this.generate(); else this.updateBar();
  };

  Configurator.prototype.setPersonalization = function (key, value) {
    if (key === 'year_from' || key === 'year_to') {
      var from = el(this.root, '[data-lm-input="year_from"]').value;
      var to = el(this.root, '[data-lm-input="year_to"]').value;
      this.state.personalization.date_range = (from || to) ? (from + ' - ' + to) : '';
    } else {
      this.state.personalization[key] = value;
    }
    if (this.state.templateId) this.generate();
  };

  Configurator.prototype.generate = function () {
    var self = this;
    if (!this.state.uploads.length || !this.state.templateId) return;

    var preview = el(this.root, '[data-lm-preview]');
    var skeleton = el(this.root, '[data-lm-skeleton]');
    var progress = el(this.root, '[data-lm-progress]');
    var errEl = el(this.root, '[data-lm-style-error]');

    preview.hidden = false;
    skeleton.hidden = false;
    errEl.hidden = true;
    this.state.previewId = null;
    this.updateBar();

    var msgs = PROGRESS[this.state.collection] || PROGRESS.regal;
    var i = 0;
    progress.textContent = msgs[0];
    var tick = setInterval(function () { i = (i + 1) % msgs.length; progress.textContent = msgs[i]; }, 1400);
    var t0 = performance.now();

    fetch(this.api + '/previews', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.state.sessionToken },
      body: JSON.stringify({
        upload_ids: this.state.uploads.map(function (u) { return u.id; }),
        template_id: this.state.templateId,
        species: this.state.species || 'auto',
        personalization: this.state.personalization,
        adjust: this.state.adjust.filter(Boolean)
      })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        clearInterval(tick);
        skeleton.hidden = true;
        if (!res.ok || res.body.status === 'failed') {
          errEl.textContent = (res.body && res.body.message) || 'We could not build that preview. Try another style.';
          errEl.hidden = false;
          self.setSubmit('Try another photo or style', true);
          return;
        }
        var p = res.body;
        self.state.previewId = p.preview_id;
        self.state.previewUrl = p.preview_url;
        self.state.previewCount += 1;
        self.state.renderVersion = p.render_version || null;

        var img = el(self.root, '[data-lm-preview-img]');
        img.src = p.preview_url;
        img.alt = self.altText();
        img.classList.remove('lm-preview__image--in');
        void img.offsetWidth;
        img.classList.add('lm-preview__image--in');

        self.track('PreviewGenerated', {
          template_id: self.state.templateId,
          collection: self.state.collection,
          species: self.state.species,
          render_ms: Math.round(performance.now() - t0),
          preview_index: self.state.previewCount
        });

        self.completeStep('style');
        self.unlockStep('personalize');
        self.unlockStep('size');
        if (self.hasFrame) self.unlockStep('frame');
        self.unlockStep('extras');
        el(self.root, '[data-lm-confirm-wrap]').hidden = false;
        self.updateBar();
      })
      .catch(function () {
        clearInterval(tick);
        skeleton.hidden = true;
        errEl.textContent = 'Something went wrong. Please try again.';
        errEl.hidden = false;
        self.setSubmit('Try again', true);
      });
  };

  /* ---------------- Adjust-Dialog (Position / Groesse / Drehung je Tier) ---------------- */
  Configurator.prototype.openAdjust = function () {
    var self = this;
    var dlg = el(this.root, '[data-lm-adjust]');
    if (!dlg || !this.state.uploads.length) return;
    var petSel = el(dlg, '[data-lm-adjust-pet]');
    petSel.innerHTML = this.state.uploads.map(function (u, i) { return '<option value="' + i + '">Pet ' + (i + 1) + '</option>'; }).join('');
    petSel.parentElement.hidden = this.state.uploads.length < 2;
    var fields = { offset_x: 0, offset_y: 0, scale: 1, rotation_deg: 0 };
    function load(i) {
      var a = self.state.adjust[i] || {};
      Object.keys(fields).forEach(function (k) {
        var inp = el(dlg, '[data-lm-adjust-field="' + k + '"]');
        inp.value = a[k] != null ? a[k] : fields[k];
        inp.dispatchEvent(new Event('input'));
      });
    }
    function read() {
      var i = Number(petSel.value || 0);
      var a = { upload_id: self.state.uploads[i].id };
      Object.keys(fields).forEach(function (k) { a[k] = parseFloat(el(dlg, '[data-lm-adjust-field="' + k + '"]').value); });
      self.state.adjust[i] = a;
    }
    if (!dlg.dataset.bound) {
      dlg.dataset.bound = '1';
      petSel.addEventListener('change', function () { load(Number(petSel.value)); });
      els(dlg, '[data-lm-adjust-field]').forEach(function (inp) {
        inp.addEventListener('input', function () {
          var out = el(dlg, '[data-lm-adjust-out="' + inp.dataset.lmAdjustField + '"]');
          if (out) out.textContent = inp.dataset.lmAdjustField === 'scale' ? Math.round(inp.value * 100) + '%' : (inp.dataset.lmAdjustField === 'rotation_deg' ? inp.value + '°' : Math.round(inp.value * 100));
          read();
        });
      });
      el(dlg, '[data-lm-adjust-reset]').addEventListener('click', function () { self.state.adjust[Number(petSel.value || 0)] = null; load(Number(petSel.value || 0)); });
      el(dlg, '[data-lm-adjust-apply]').addEventListener('click', function () {
        read();
        dlg.close();
        self.track('PreviewAdjusted', { template_id: self.state.templateId });
        self.generate();
      });
      el(dlg, '[data-lm-adjust-close]').addEventListener('click', function () { dlg.close(); });
    }
    load(0);
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
  };

  /* Der Alt-Text nennt die echte Produktform. Vorher hiess jede Nicht-Leinwand "print" —
     "11 oz print" beschreibt keinen Becher. */
  var FORM_NOUN = { canvas: 'canvas', poster: 'poster', blanket: 'blanket', pillow: 'pillow', mug: 'mug', ornament: 'ornament' };
  Configurator.prototype.altText = function () {
    var noun = FORM_NOUN[this.form] || 'print';
    var parts = ['Portrait of a ' + (this.state.species || 'pet')];
    if (this.state.templateName) parts.push('in the ' + this.state.templateName + ' style');
    if (this.form === 'mug' || this.form === 'ornament') parts.push('on a ' + noun);
    else if (this.state.size) parts.push(this.state.size + ' ' + noun);
    else parts.push('on a ' + noun);
    if (this.state.frame && this.state.frame !== 'Unframed') parts.push(this.state.frame.toLowerCase() + ' frame');
    return parts.join(', ');
  };

  /* ---------------- Groesse und Rahmen aus den Varianten ---------------- */

  Configurator.prototype.optionIndex = function (name) {
    for (var i = 0; i < this.optionNames.length; i++) {
      if (this.optionNames[i] === name) return i;
    }
    return -1;
  };

  Configurator.prototype.uniqueOption = function (name) {
    var idx = this.optionIndex(name);
    if (idx < 0) return [];
    var seen = {}, out = [];
    this.variants.forEach(function (v) {
      var val = v.options[idx];
      if (val && !seen[val]) { seen[val] = 1; out.push(val); }
    });
    return out;
  };

  Configurator.prototype.priceFor = function (size, frame, pets) {
    var si = this.optionIndex('Size'), fi = this.optionIndex('Frame'), pi = this.optionIndex('Pets');
    for (var i = 0; i < this.variants.length; i++) {
      var v = this.variants[i];
      if (si >= 0 && v.options[si] !== size) continue;
      if (fi >= 0 && frame && v.options[fi] !== frame) continue;
      if (pi >= 0 && v.options[pi] !== String(pets)) continue;
      return v;
    }
    return null;
  };

  /* Der Shop verkauft in den USA, die Groessen kommen aus dem Printify-Blueprint und sind Zoll:
     9x12, 12x16, 18x24, 24x32. Ohne Einheit ist "9x12" fuer einen Teil der Kunden zweideutig
     (in Europa liest man Zentimeter) - und ein Kunde, der 9x12 cm erwartet, storniert.
     Das Doppelprime steht in den USA fuer Zoll. Der Optionswert selbst bleibt unveraendert:
     er geht so an den Warenkorb und an Printify. Groessen, die keine reinen Zollmasse sind
     ("18x18 Cover only", "Round"), bleiben unangetastet. */
  function inches(v) {
    var m = /^\s*(\d+)\s*[x\u00d7]\s*(\d+)\s*$/i.exec(v || '');
    return m ? m[1] + '\u2033 \u00d7 ' + m[2] + '\u2033' : v;
  }

  Configurator.prototype.renderSizes = function () {
    var self = this;
    var box = el(this.root, '[data-lm-sizes]');
    var sizes = this.uniqueOption('Size');
    var pets = Math.max(1, this.state.uploads.length);
    var popular = sizes.length > 1 ? sizes[1] : sizes[0];

    box.innerHTML = sizes.map(function (s) {
      var v = self.priceFor(s, self.hasFrame ? 'Unframed' : null, pets);
      return '<button type="button" class="lm-size" role="radio" aria-checked="false" data-size="' + s + '">' +
             '<span class="lm-size__label">' + inches(s) + '</span>' +
             '<span class="lm-size__price">' + (v ? money(v.price) : '') + '</span>' +
             (s === popular ? '<span class="lm-badge lm-badge--bestseller">Most popular</span>' : '') +
             '</button>';
    }).join('');

    if (!this.state.size && sizes.length) this.state.size = sizes[0]; /* Vorauswahl kleinste Groesse = "From"-Preis, ehrlich */
    els(box, '.lm-size').forEach(function (b) {
      if (b.dataset.size === self.state.size) b.setAttribute('aria-checked', 'true');
      b.addEventListener('click', function () {
        els(box, '.lm-size').forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
        b.setAttribute('aria-checked', 'true');
        self.state.size = b.dataset.size;
        self.completeStep('size');
        if (self.hasFrame) self.renderFrames();
        self.updateBar();
      });
    });
  };

  Configurator.prototype.renderFrames = function () {
    var self = this;
    var box = el(this.root, '[data-lm-frames]');
    if (!box) return;
    var frames = this.uniqueOption('Frame');
    var pets = Math.max(1, this.state.uploads.length);
    var baseSize = this.state.size || this.uniqueOption('Size')[0];
    var base = this.priceFor(baseSize, 'Unframed', pets);

    box.innerHTML = frames.map(function (f) {
      var v = self.priceFor(baseSize, f, pets);
      var delta = (v && base) ? v.price - base.price : 0;
      /* "Unframed" ist der Grundfall und bekommt die volle Breite; die vier Holzfarben stehen darunter
         im gleichmaessigen Raster. Sein Feld traegt einen Schraegstrich statt einer transparenten
         Flaeche - ein leeres Kaestchen las sich wie ein nicht geladenes Bild. */
      var isNone = (f === 'Unframed');
      return '<button type="button" class="lm-frame' + (isNone ? ' lm-frame--none' : '') + '" role="radio" aria-checked="' + (f === (self.state.frame || 'Unframed')) + '" data-frame="' + f + '">' +
             '<span class="lm-frame__swatch' + (isNone ? ' lm-frame__swatch--none' : '') + '"' + (isNone ? '' : ' style="background:' + (FRAME_SWATCH[f] || '#ccc') + '"') + ' aria-hidden="true"></span>' +
             '<span class="lm-frame__label">' + f + '</span>' +
             '<span class="lm-frame__price">' + (delta > 0 ? '+' + money(delta) : 'included') + '</span>' +
             '</button>';
    }).join('');

    els(box, '.lm-frame').forEach(function (b) {
      b.addEventListener('click', function () {
        els(box, '.lm-frame').forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
        b.setAttribute('aria-checked', 'true');
        self.state.frame = b.dataset.frame;
        // Rahmenwechsel ist rein visuell, kein Serverjob
        var overlay = el(self.root, '[data-lm-frame-overlay]');
        overlay.className = 'lm-preview__frame lm-preview__frame--' + b.dataset.frame.toLowerCase();
        var img = el(self.root, '[data-lm-preview-img]');
        if (img) img.alt = self.altText();
        self.updateBar();
      });
    });
  };

  /* ---------------- Schrittsteuerung ---------------- */

  Configurator.prototype.stepEl = function (name) { return el(this.root, '[data-lm-step="' + name + '"]'); };

  Configurator.prototype.unlockStep = function (name) {
    var s = this.stepEl(name);
    if (s && s.dataset.state === 'locked') s.dataset.state = 'open';
  };

  Configurator.prototype.completeStep = function (name) {
    var s = this.stepEl(name);
    if (!s) return;
    s.dataset.state = 'done';
    var c = el(s, '[data-lm-step-check]');
    if (c) c.hidden = false;
  };

  Configurator.prototype.focusStep = function (name) {
    var s = this.stepEl(name);
    if (!s) return;
    s.dataset.state = s.dataset.state === 'locked' ? 'open' : s.dataset.state;
    s.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  /* ---------------- Preisleiste ---------------- */

  Configurator.prototype.currentVariant = function () {
    var pets = Math.max(1, this.state.uploads.length);
    var size = this.state.size || this.uniqueOption('Size')[0];
    return this.priceFor(size, this.state.frame, pets);
  };

  Configurator.prototype.addonTotal = function () {
    var self = this, sum = 0;
    els(this.root, '[data-lm-addon]').forEach(function (cb) {
      if (self.state.addons.indexOf(cb.dataset.lmAddon) > -1) sum += Math.round(parseFloat(cb.dataset.price || '0') * 100);
    });
    return sum;
  };

  Configurator.prototype.updateBar = function () {
    var v = this.currentVariant();
    var total = (v ? v.price : 0) + this.addonTotal();
    var btn = el(this.root, '[data-lm-submit]');

    var fill = el(this.root, '[data-lm-ship-fill]');
    var text = el(this.root, '[data-lm-ship-text]');
    var pct = Math.min(100, (total / this.threshold) * 100);
    fill.style.width = pct + '%';
    /* Der Betrag ist die Information, der Rest ist Satzbau - er wird hervorgehoben. */
    text.innerHTML = total >= this.threshold
      ? '<b>Free US shipping unlocked</b>'
      : '<b>' + money(this.threshold - total) + '</b> away from free shipping';

    var tot = el(this.root, '[data-lm-total]');
    if (tot) tot.textContent = money(total);

    if (this.busy) return;
    /* Zweite Zeile je Schritt: sie beantwortet die Frage, die an dieser Stelle im Kopf steht.
       Vor dem Upload "kostet mich das was?", vor dem Stil "nur einmal?", vor dem Kauf "und wenn
       es nicht aussieht wie mein Tier?". */
    if (!this.state.uploads.length) { this.setSubmit('Upload photo — free preview', false, 'No payment until you love it'); return; }
    if (!this.state.templateId) { this.setSubmit('Pick a style — free preview', false, 'Try as many as you like'); return; }
    if (!this.state.previewId) { this.setSubmit('Building your preview…', true, 'About ten seconds'); return; }
    this.setSubmit('Add to cart — ' + money(total), false, 'Likeness guaranteed — reprint or refund');
  };

  var CTA_ARROW = '<svg class="lm-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 12h15"/><path d="m13.4 5.8 6.1 6.2-6.1 6.2"/></svg>';

  Configurator.prototype.setSubmit = function (label, disabled, sub) {
    var btn = el(this.root, '[data-lm-submit]');
    /* textContent waere hier falsch: der Knopf traegt zwei Zeilen und einen Pfeil. Beide Texte
       kommen aus diesem Modul, nicht aus einer Eingabe - trotzdem wird escaped, weil money()
       eines Tages ein Shop-Format mit spitzen Klammern liefern koennte. */
    function esc(t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
    var html = '<span class="lm-cta__text"><span class="lm-cta__main">' + esc(label) + '</span>';
    if (sub) html += '<span class="lm-cta__sub">' + esc(sub) + '</span>';
    html += '</span><span class="lm-cta__arrow" aria-hidden="true">' + CTA_ARROW + '</span>';
    btn.innerHTML = html;
    btn.disabled = !!disabled;
  };

  /* Checkbox "looks like my pet" anstupsen statt Button sperren */
  Configurator.prototype.nudgeConfirm = function () {
    var wrap = el(this.root, '[data-lm-confirm-wrap]');
    var errEl = el(this.root, '[data-lm-cart-error]');
    wrap.hidden = false;
    wrap.classList.remove('is-nudge'); void wrap.offsetWidth; wrap.classList.add('is-nudge');
    errEl.textContent = 'Please confirm the preview looks like your pet — that is our print approval.';
    errEl.hidden = false;
    var cb = el(wrap, 'input'); if (cb) cb.focus();
  };

  /* ---------------- Warenkorb ---------------- */

  Configurator.prototype.submit = function () {
    var self = this;
    var v = this.currentVariant();
    var errEl = el(this.root, '[data-lm-cart-error]');
    errEl.hidden = true;
    if (!this.state.uploads.length) { this.focusStep('photo'); el(this.root, '[data-lm-file]').click(); return; }
    if (!this.state.templateId) { this.focusStep('style'); return; }
    if (!this.state.previewId) return;
    if (!this.state.confirmed) { this.nudgeConfirm(); return; }
    if (!v) { errEl.textContent = 'That combination is not available.'; errEl.hidden = false; return; }

    var props = {
      '_preview_job_id': this.state.previewId,
      '_preview_url': this.state.previewUrl,
      '_upload_ids': this.state.uploads.map(function (u) { return u.id; }).join(','),
      '_species': this.state.species || 'unknown',
      '_render_version': this.state.renderVersion || '',
      '_addons': this.state.addons.join(','),
      '_approved_at': this.state.approvedAt || new Date().toISOString(),
      '_form': this.form,
      'Style': this.state.collection.charAt(0).toUpperCase() + this.state.collection.slice(1),
      'Design': this.state.templateName || this.state.templateId,
      'Pet': this.state.species === 'cat' ? 'Cat' : 'Dog',
      '_pets': String(Math.max(1, this.state.uploads.length))
    };
    if (this.state.personalization.pet_name) props["Pet's name"] = this.state.personalization.pet_name;
    if (this.state.personalization.dedication) props['Dedication'] = this.state.personalization.dedication;
    if (this.state.personalization.date_range) props['Years'] = this.state.personalization.date_range;
    if (this.state.personalization.background) props['Background'] = this.state.personalization.background;
    if (this.state.addons.indexOf('gift') > -1) props['Gift'] = 'Yes — reveal card included';

    this.busy = true;
    this.setSubmit('Adding…', true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          self.busy = false;
          errEl.textContent = res.body.description || 'We could not add that to your cart.';
          errEl.hidden = false;
          self.updateBar();
          return;
        }
        self.track('AddToCart', {
          content_ids: [v.sku],
          value: (v.price + self.addonTotal()) / 100,
          currency: 'USD',
          template_id: self.state.templateId,
          size: self.state.size,
          frame: self.state.frame,
          pets: self.state.uploads.length
        });
        document.dispatchEvent(new CustomEvent('lm:cart-updated'));
        window.location.href = '/cart';
      })
      .catch(function () {
        self.busy = false;
        errEl.textContent = 'Something went wrong. Please try again.';
        errEl.hidden = false;
        self.updateBar();
      });
  };

  Configurator.prototype.emailUploadLink = function () {
    document.dispatchEvent(new CustomEvent('lm:open-email-capture', {
      detail: { template_id: this.state.templateId, collection: this.state.collection }
    }));
  };

  /* ---------------- Tracking ---------------- */

  Configurator.prototype.track = function (name, params) {
    var eventId = name + '.' + this.shopSessionId() + '.' + Date.now();
    var payload = Object.assign({ event_id: eventId }, params || {});
    if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, payload));
    if (window.fbq) {
      var std = ['AddToCart', 'InitiateCheckout', 'Purchase', 'ViewContent'];
      window.fbq(std.indexOf(name) > -1 ? 'track' : 'trackCustom', name, payload, { eventID: eventId });
    }
    document.dispatchEvent(new CustomEvent('lm:track', { detail: { name: name, payload: payload } }));
  };

  /* ---------------- Init ---------------- */

  function init() {
    els(document, '[data-lm-configurator]').forEach(function (root) {
      if (!root.__lmInit) { root.__lmInit = true; new Configurator(root); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();